module.exports = __webpack_public_path__ + "static/images/fragile.B0biD8r.svg";